module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/assessment_achievements/4_bbcd67de2f3ab9a468eb7113c10748a9.png";